export default "__VITE_ASSET__a668a504__"